(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dsiv-artist-terminal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-dsiv-artist]');

    sections.forEach((root) => {
      if (root.dataset.dsivArtistReady === 'true') return;
      root.dataset.dsivArtistReady = 'true';
      root.classList.add('is-enhanced');

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const canvas = root.querySelector('[data-dsiv-artist-signal]');
      const revealItems = root.querySelectorAll('[data-dsiv-artist-reveal]');
      let revealObserver;
      let stageObserver;
      let resizeObserver;
      let frameId = 0;
      let visible = true;
      let width = 0;
      let height = 0;
      let dpr = 1;
      let pointerX = 0.5;
      let pointerY = 0.5;
      let context;

      const refreshIcons = () => {
        if (window.lucide && typeof window.lucide.createIcons === 'function') {
          window.lucide.createIcons({ attrs: { 'aria-hidden': 'true' } });
        }
      };

      const setCanvasSize = () => {
        if (!canvas) return;
        const rect = canvas.getBoundingClientRect();
        width = Math.max(1, rect.width);
        height = Math.max(1, rect.height);
        dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        canvas.width = Math.round(width * dpr);
        canvas.height = Math.round(height * dpr);
        context = canvas.getContext('2d');
        if (context) context.setTransform(dpr, 0, 0, dpr, 0, 0);
      };

      const drawSignal = (time = 0) => {
        if (!context || !canvas) return;
        context.clearRect(0, 0, width, height);

        const phase = reducedMotion.matches ? 0.4 : time * 0.00018;
        const baseline = height * (0.7 + (pointerY - 0.5) * 0.08);
        const amplitude = Math.max(14, height * 0.055);

        context.lineWidth = 1;
        context.strokeStyle = 'rgba(118, 173, 255, 0.72)';
        context.beginPath();
        for (let x = 0; x <= width; x += 7) {
          const ratio = x / width;
          const signal = Math.sin(ratio * 24 + phase * 10) * 0.42
            + Math.sin(ratio * 53 - phase * 7) * 0.2;
          const y = baseline + signal * amplitude + (pointerX - 0.5) * 8;
          if (x === 0) context.moveTo(x, y);
          else context.lineTo(x, y);
        }
        context.stroke();

        const nodes = [
          [0.18, 0.24],
          [0.5, 0.18],
          [0.78, 0.3]
        ];
        nodes.forEach((node, index) => {
          const x = width * node[0];
          const y = baseline + Math.sin(node[0] * 24 + phase * 10) * amplitude * 0.42;
          context.beginPath();
          context.arc(x, y, index === 1 ? 4.5 : 3.5, 0, Math.PI * 2);
          context.fillStyle = index === 1 ? 'rgba(231, 182, 85, 0.95)' : 'rgba(255, 255, 255, 0.9)';
          context.fill();
        });
      };

      const stop = () => {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = 0;
      };

      const render = (time) => {
        frameId = 0;
        drawSignal(time);
        if (visible && !document.hidden && !reducedMotion.matches) {
          frameId = requestAnimationFrame(render);
        }
      };

      const start = () => {
        stop();
        drawSignal(performance.now());
        if (visible && !document.hidden && !reducedMotion.matches) {
          frameId = requestAnimationFrame(render);
        }
      };

      const onPointerMove = (event) => {
        if (!canvas || reducedMotion.matches) return;
        const rect = canvas.getBoundingClientRect();
        pointerX = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
        pointerY = Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height));
      };

      const onVisibilityChange = () => {
        if (document.hidden) stop();
        else start();
      };

      const onMotionChange = () => start();

      const onSectionUnload = (event) => {
        if (!event.target) return;
        if (event.target === root || event.target.contains(root)) destroy();
      };

      if ('IntersectionObserver' in window) {
        revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0.14 });
        revealItems.forEach((item) => revealObserver.observe(item));

        if (canvas) {
          stageObserver = new IntersectionObserver((entries) => {
            visible = entries[0] ? entries[0].isIntersecting : true;
            if (visible) start();
            else stop();
          }, { threshold: 0.05 });
          stageObserver.observe(canvas);
        }
      } else {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      }

      if (canvas) {
        setCanvasSize();
        if ('ResizeObserver' in window) {
          resizeObserver = new ResizeObserver(() => {
            setCanvasSize();
            drawSignal(performance.now());
          });
          resizeObserver.observe(canvas);
        } else {
          window.addEventListener('resize', setCanvasSize, { passive: true });
        }
        canvas.addEventListener('pointermove', onPointerMove, { passive: true });
        document.addEventListener('visibilitychange', onVisibilityChange);
        if (typeof reducedMotion.addEventListener === 'function') {
          reducedMotion.addEventListener('change', onMotionChange);
        } else {
          reducedMotion.addListener(onMotionChange);
        }
        start();
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', refreshIcons, { once: true });
      } else {
        refreshIcons();
      }
      window.addEventListener('load', refreshIcons, { once: true });

      const destroy = () => {
        stop();
        if (revealObserver) revealObserver.disconnect();
        if (stageObserver) stageObserver.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        if (canvas) canvas.removeEventListener('pointermove', onPointerMove);
        window.removeEventListener('resize', setCanvasSize);
        document.removeEventListener('visibilitychange', onVisibilityChange);
        if (typeof reducedMotion.removeEventListener === 'function') {
          reducedMotion.removeEventListener('change', onMotionChange);
        } else {
          reducedMotion.removeListener(onMotionChange);
        }
        document.removeEventListener('shopify:section:unload', onSectionUnload);
      };

      document.addEventListener('shopify:section:unload', onSectionUnload);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-collection-terminal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function normalize(value) {
      return String(value || "").trim().toLowerCase();
    }

    function cardValue(card, key) {
      return card.getAttribute("data-dsiv-" + key) || "";
    }

    function numericCardValue(card, key) {
      var raw = cardValue(card, key).replace(/[^\d.]/g, "");
      if (!raw) return null;
      var parsed = Number(raw);
      return Number.isFinite(parsed) ? parsed : null;
    }

    function populateFilter(select, cards, key) {
      if (!select) return;
      var firstOption = select.querySelector("option");
      select.innerHTML = "";
      if (firstOption) select.appendChild(firstOption);
      Array.from(new Set(cards.map(function (card) {
        return cardValue(card, key).trim();
      }).filter(Boolean))).sort(function (left, right) {
        return left.localeCompare(right, undefined, { sensitivity: "base" });
      }).forEach(function (value) {
        var option = document.createElement("option");
        option.value = normalize(value);
        option.textContent = value;
        select.appendChild(option);
      });
    }

    function compareNumber(left, right, key, direction) {
      var leftValue = numericCardValue(left, key);
      var rightValue = numericCardValue(right, key);
      if (leftValue === null && rightValue === null) return 0;
      if (leftValue === null) return 1;
      if (rightValue === null) return -1;
      return direction === "desc" ? rightValue - leftValue : leftValue - rightValue;
    }

    function formatTime(seconds) {
      var safe = Number.isFinite(seconds) ? Math.max(0, seconds) : 0;
      return Math.floor(safe / 60) + ":" + String(Math.floor(safe % 60)).padStart(2, "0");
    }

    function parseDuration(value) {
      var parts = String(value || "").trim().split(":").map(Number);
      if (parts.length === 2 && parts.every(Number.isFinite)) return parts[0] * 60 + parts[1];
      var numeric = Number(value);
      return Number.isFinite(numeric) ? numeric : 0;
    }

    function createVisualizer(canvas, audio) {
      var context = null;
      var analyser = null;
      var frequencyData = null;
      var gl = null;
      var program = null;
      var resolutionLocation = null;
      var bandsLocation = null;
      var fallback = null;
      var frame = 0;
      var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

      function compile(type, source) {
        var shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) return null;
        return shader;
      }

      function initCanvas() {
        if (gl || fallback) return;
        try {
          gl = canvas.getContext("webgl", { alpha: true, antialias: false, depth: false });
          if (!gl) throw new Error("WebGL unavailable");
          var vertex = compile(gl.VERTEX_SHADER, "attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}");
          var fragment = compile(gl.FRAGMENT_SHADER, "precision mediump float;uniform vec2 r;uniform float b[24];void main(){vec2 u=gl_FragCoord.xy/r;float x=floor(u.x*24.);float a=.06;for(int i=0;i<24;i++){if(abs(float(i)-x)<.5)a=max(a,b[i]);}float gap=step(.12,fract(u.x*24.));float bar=step(abs(u.y-.5),a*.34)*gap;float line=.01/max(abs(u.y-.5),.01);vec3 c=vec3(.106,.341,.839)*bar*(.8+a)+vec3(.52,.72,1.)*line*.08;gl_FragColor=vec4(c,clamp(bar+line*.06,0.,.9));}");
          if (!vertex || !fragment) throw new Error("Shader unavailable");
          program = gl.createProgram();
          gl.attachShader(program, vertex);
          gl.attachShader(program, fragment);
          gl.linkProgram(program);
          if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error("Program unavailable");
          gl.useProgram(program);
          var buffer = gl.createBuffer();
          gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
          gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), gl.STATIC_DRAW);
          var position = gl.getAttribLocation(program, "p");
          gl.enableVertexAttribArray(position);
          gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
          resolutionLocation = gl.getUniformLocation(program, "r");
          bandsLocation = gl.getUniformLocation(program, "b[0]");
        } catch (error) {
          gl = null;
          fallback = canvas.getContext("2d");
        }
      }

      function initAudio() {
        if (analyser || context === false) return;
        var AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) {
          context = false;
          return;
        }
        try {
          context = new AudioContextClass();
          analyser = context.createAnalyser();
          analyser.fftSize = 256;
          analyser.smoothingTimeConstant = 0.78;
          frequencyData = new Uint8Array(analyser.frequencyBinCount);
          var source = context.createMediaElementSource(audio);
          source.connect(analyser);
          analyser.connect(context.destination);
        } catch (error) {
          context = false;
        }
      }

      function sampleBands() {
        var bands = new Float32Array(24);
        if (analyser && !audio.paused && !reducedMotion.matches) {
          analyser.getByteFrequencyData(frequencyData);
          for (var index = 0; index < 24; index += 1) {
            var start = Math.floor(index * frequencyData.length / 48);
            var end = Math.max(start + 1, Math.floor((index + 1) * frequencyData.length / 48));
            var total = 0;
            for (var bucket = start; bucket < end; bucket += 1) total += frequencyData[bucket];
            bands[index] = total / (end - start) / 255;
          }
        } else {
          for (var idle = 0; idle < 24; idle += 1) bands[idle] = 0.08 + Math.sin(idle * 0.72) * 0.025;
        }
        return bands;
      }

      function draw() {
        initCanvas();
        var rect = canvas.getBoundingClientRect();
        var ratio = Math.min(window.devicePixelRatio || 1, 1.5);
        var width = Math.max(1, Math.round(rect.width * ratio));
        var height = Math.max(1, Math.round(rect.height * ratio));
        if (canvas.width !== width || canvas.height !== height) {
          canvas.width = width;
          canvas.height = height;
        }
        var bands = sampleBands();
        if (gl) {
          gl.viewport(0, 0, width, height);
          gl.uniform2f(resolutionLocation, width, height);
          gl.uniform1fv(bandsLocation, bands);
          gl.drawArrays(gl.TRIANGLES, 0, 6);
        } else if (fallback) {
          fallback.clearRect(0, 0, width, height);
          var barWidth = width / 24;
          bands.forEach(function (band, index) {
            var barHeight = Math.max(3, band * height * 0.66);
            fallback.fillStyle = index % 3 === 0 ? "#8fb4ff" : "#1b57d6";
            fallback.fillRect(index * barWidth + 2, height / 2 - barHeight / 2, Math.max(2, barWidth - 5), barHeight);
          });
        }
        window.cancelAnimationFrame(frame);
        if (!audio.paused && !document.hidden && !reducedMotion.matches) frame = window.requestAnimationFrame(draw);
      }

      return {
        resume: function () {
          initAudio();
          return context && context.state === "suspended" ? context.resume() : Promise.resolve();
        },
        draw: draw,
        stop: function () { window.cancelAnimationFrame(frame); }
      };
    }

    function initCatalogSection(root) {
      if (!root || root.dataset.dsivCatalogReady === "true") return;
      var grid = root.querySelector("[data-dsiv-catalog-grid]");
      var initialCards = Array.from(root.querySelectorAll("[data-dsiv-track-card]"));
      var cards = initialCards.slice();
      if (!grid || !cards.length) return;

      root.dataset.dsivCatalogReady = "true";
      var search = root.querySelector("[data-dsiv-catalog-search]");
      var initialQuery = new URLSearchParams(window.location.search).get("q");
      if (search && initialQuery) search.value = initialQuery;
      var genre = root.querySelector('[data-dsiv-catalog-filter="genre"]');
      var albumNavigation = root.querySelector("[data-dsiv-catalog-album]");
      var license = root.querySelector('[data-dsiv-catalog-filter="license"]');
      var key = root.querySelector('[data-dsiv-catalog-filter="key"]');
      var preview = root.querySelector('[data-dsiv-catalog-filter="preview"]');
      var availability = root.querySelector('[data-dsiv-catalog-filter="availability"]');
      var sort = root.querySelector("[data-dsiv-catalog-sort]");
      var reset = root.querySelector("[data-dsiv-catalog-reset]");
      var count = root.querySelector("[data-dsiv-catalog-count]");
      var empty = root.querySelector("[data-dsiv-catalog-empty]");
      var tools = root.querySelector(".dsiv-collection-terminal__tools");
      var pagination = root.querySelector(".dsiv-collection-terminal__pagination");
      var loadMore = root.querySelector("[data-dsiv-catalog-load-more]");
      var indexStatus = root.querySelector("[data-dsiv-catalog-index-status]");
      var audio = root.querySelector("[data-dsiv-shared-audio]");
      var player = root.querySelector("[data-dsiv-shared-player]");
      var playerTitle = root.querySelector("[data-dsiv-player-title]");
      var playerFacts = root.querySelector("[data-dsiv-player-facts]");
      var playerStatus = root.querySelector("[data-dsiv-player-status]");
      var playerTime = root.querySelector("[data-dsiv-player-time]");
      var liveStatus = root.querySelector("[data-dsiv-player-live]");
      var canvas = root.querySelector("[data-dsiv-player-canvas]");
      var visualizer = createVisualizer(canvas, audio);
      var activeCard = null;
      var plural = root.dataset.dsivCountPlural || "tracks shown";
      var singular = root.dataset.dsivCountSingular || "track shown";
      var playLabel = root.dataset.dsivPlayLabel || "Play";
      var pauseLabel = root.dataset.dsivPauseLabel || "Pause";
      var readyLabel = root.dataset.dsivPreviewReady || "Preview ready";
      var playingLabel = root.dataset.dsivPreviewPlaying || "Playing preview";
      var errorLabel = root.dataset.dsivPreviewError || "Preview unavailable";
      var totalPages = Number(tools && tools.dataset.dsivCatalogPageCount || 1);
      var currentPage = Number(tools && tools.dataset.dsivCatalogCurrentPage || 1);
      var totalItems = Number(tools && tools.dataset.dsivCatalogTotalItems || cards.length);
      var pageSize = Math.max(1, Number(tools && tools.dataset.dsivCatalogPageSize || 0) || cards.length || 48);
      var indexedPages = new Set([currentPage]);
      var cardKeys = new Set();
      var pageLoadFailed = false;
      var activePageRequest = null;
      var fullIndexRequest = null;
      var visibleLimit = pageSize;
      var indexReady = totalPages <= 1;
      var destroyed = false;
      var abortController = typeof window.AbortController === "function" ? new window.AbortController() : null;
      var fallbackPaginationControls = pagination ? Array.from(pagination.querySelectorAll("a, span")) : [];
      var discoveryControls = [search, genre, license, key, preview, availability, sort, reset].filter(Boolean);

      function setFallbackPaginationVisible(visible) {
        fallbackPaginationControls.forEach(function (control) { control.hidden = !visible; });
      }

      function setDiscoveryDisabled(disabled) {
        discoveryControls.forEach(function (control) { control.disabled = Boolean(disabled); });
      }

      function cardIdentity(card) {
        return cardValue(card, "url") || cardValue(card, "title");
      }

      function setupCard(card, pageNumber, index) {
        card.dataset.dsivOriginalIndex = String((pageNumber - 1) * pageSize + index);
        cardKeys.add(cardIdentity(card));
        var duration = parseDuration(cardValue(card, "duration"));
        if (duration) card.dataset.dsivDurationSeconds = String(duration);
        updateCardProgress(card, 0);
      }

      initialCards.forEach(function (card, index) { setupCard(card, currentPage, index); });

      function setIndexStatus(message, hidden) {
        if (!indexStatus) return;
        indexStatus.textContent = message;
        indexStatus.hidden = Boolean(hidden);
      }

      function updateCardProgress(card, seconds) {
        if (!card) return;
        var duration = Number(card.dataset.dsivDurationSeconds || 0);
        if (card === activeCard && Number.isFinite(audio.duration)) duration = audio.duration;
        var safe = Math.min(Math.max(Number(seconds) || 0, 0), duration || 0);
        var progress = duration ? safe / duration * 100 : 0;
        var waveform = card.querySelector("[data-dsiv-waveform]");
        var timeline = card.querySelector("[data-dsiv-timeline]");
        var rowStatus = card.querySelector("[data-dsiv-row-status]");
        if (waveform) waveform.style.setProperty("--dsiv-progress", progress + "%");
        if (timeline) {
          timeline.max = duration || 100;
          timeline.value = safe;
          timeline.setAttribute("aria-valuemin", "0");
          timeline.setAttribute("aria-valuemax", String(duration || 100));
          timeline.setAttribute("aria-valuenow", String(safe));
          timeline.setAttribute("aria-valuetext", formatTime(safe) + (duration ? " / " + formatTime(duration) : ""));
        }
        if (rowStatus && card === activeCard) rowStatus.textContent = formatTime(safe) + (duration ? " / " + formatTime(duration) : "");
        if (playerTime && card === activeCard) {
          playerTime.textContent = formatTime(safe) + (duration ? " / " + formatTime(duration) : "");
          playerTime.setAttribute("datetime", "PT" + Math.floor(safe) + "S");
        }
      }

      function refreshPlaybackState() {
        var isPlaying = activeCard && !audio.paused && !audio.ended;
        cards.forEach(function (card) {
          var button = card.querySelector("[data-dsiv-audio-toggle]");
          var cardIsPlaying = card === activeCard && isPlaying;
          card.classList.toggle("is-playing", cardIsPlaying);
          if (button) {
            button.setAttribute("aria-pressed", cardIsPlaying ? "true" : "false");
            button.setAttribute("aria-label", (cardIsPlaying ? pauseLabel : playLabel) + " " + cardValue(card, "title"));
          }
        });
        if (playerStatus) playerStatus.textContent = isPlaying ? playingLabel : readyLabel;
      }

      function prepareCard(card, requestedSeconds) {
        if (!card || cardValue(card, "preview") !== "true") return false;
        var requested = Number(requestedSeconds);
        var hasRequestedTime = Number.isFinite(requested) && requested >= 0;
        if (card === activeCard && audio.src) {
          if (hasRequestedTime) {
            card.dataset.dsivPendingSeek = String(requested);
            if (!audio.readyState || !applyPendingSeek()) updateCardProgress(card, requested);
          }
          return true;
        }
        audio.pause();
        if (activeCard) updateCardProgress(activeCard, 0);
        activeCard = card;
        audio.src = cardValue(card, "preview-url");
        if (hasRequestedTime) card.dataset.dsivPendingSeek = String(requested);
        audio.load();
        player.hidden = false;
        playerTitle.textContent = cardValue(card, "title");
        playerFacts.textContent = [cardValue(card, "genre"), cardValue(card, "moods"), cardValue(card, "bpm") ? cardValue(card, "bpm") + " BPM" : ""].filter(Boolean).join(" / ");
        updateCardProgress(card, hasRequestedTime ? requested : 0);
        refreshPlaybackState();
        visualizer.draw();
        return true;
      }

      function repopulateFilter(select, attribute) {
        if (!select) return;
        var selected = select.value;
        populateFilter(select, cards, attribute);
        if (!selected) return;
        select.value = Array.from(select.options).some(function (option) { return option.value === selected; }) ? selected : "";
      }

      function refreshFilterOptions() {
        repopulateFilter(genre, "genre");
        repopulateFilter(license, "license");
        repopulateFilter(key, "key");
      }

      function matchesSelect(card, select, attribute) {
        return !select || !select.value || normalize(cardValue(card, attribute)) === select.value;
      }

      function matchesSearch(card) {
        var query = normalize(search && search.value);
        if (!query) return true;
        return ["title", "type", "genre", "license", "key", "bpm", "moods"].map(function (attribute) {
          return cardValue(card, attribute);
        }).join(" ").toLowerCase().includes(query);
      }

      function sortedCards() {
        var ordered = cards.slice();
        var mode = sort && sort.value ? sort.value : "recommended";
        ordered.sort(function (left, right) {
          if (mode === "title-asc") return cardValue(left, "title").localeCompare(cardValue(right, "title"), undefined, { sensitivity: "base" });
          if (mode === "price-asc") return compareNumber(left, right, "price", "asc");
          if (mode === "price-desc") return compareNumber(left, right, "price", "desc");
          if (mode === "bpm-asc") return compareNumber(left, right, "bpm", "asc");
          if (mode === "bpm-desc") return compareNumber(left, right, "bpm", "desc");
          return Number(left.dataset.dsivOriginalIndex || 0) - Number(right.dataset.dsivOriginalIndex || 0);
        });
        return ordered;
      }

      function cardMatchesFilters(card) {
        var previewMode = preview && preview.value ? preview.value : "";
        return matchesSearch(card)
          && matchesSelect(card, genre, "genre")
          && matchesSelect(card, license, "license")
          && matchesSelect(card, key, "key")
          && (!previewMode || cardValue(card, "preview") === previewMode)
          && matchesSelect(card, availability, "available");
      }

      function applyFilters() {
        if (!indexReady) {
          initialCards.forEach(function (card) { card.hidden = false; });
          grid.replaceChildren.apply(grid, initialCards);
          if (count) {
            var initialLabel = initialCards.length === 1 ? singular : plural;
            count.textContent = totalItems > initialCards.length
              ? initialCards.length + " / " + totalItems + " " + initialLabel
              : initialCards.length + " " + initialLabel;
          }
          if (empty) empty.hidden = true;
          if (loadMore) loadMore.hidden = true;
          if (pagination) pagination.hidden = totalPages <= 1;
          return {
            matchedCount: initialCards.length,
            visibleCount: initialCards.length,
            hasMore: totalPages > 1,
            visibleCards: initialCards.slice(),
          };
        }

        var matchedCards = sortedCards().filter(cardMatchesFilters);
        var visibleCards = matchedCards.slice(0, visibleLimit);
        var visibleSet = new Set(visibleCards);
        cards.forEach(function (card) { card.hidden = !visibleSet.has(card); });
        if (activeCard && !visibleSet.has(activeCard) && !audio.paused) audio.pause();
        grid.replaceChildren.apply(grid, visibleCards);
        var visibleCount = visibleCards.length;
        var matchedCount = matchedCards.length;
        if (count) {
          var label = visibleCount === 1 ? singular : plural;
          count.textContent = matchedCount > visibleCount
            ? visibleCount + " / " + matchedCount + " " + label
            : visibleCount + " " + label;
        }
        if (empty) empty.hidden = matchedCount !== 0;
        var hasMore = matchedCount > visibleCount;
        if (loadMore) loadMore.hidden = !hasMore;
        if (pagination) pagination.hidden = !hasMore;
        return {
          matchedCount: matchedCount,
          visibleCount: visibleCount,
          hasMore: hasMore,
          visibleCards: visibleCards,
        };
      }

      root.addEventListener("click", function (event) {
        var button = event.target.closest && event.target.closest("[data-dsiv-audio-toggle]");
        if (!button || !root.contains(button) || button.disabled) return;
        var card = button.closest("[data-dsiv-track-card]");
        event.preventDefault();
        if (card === activeCard && !audio.paused) {
          audio.pause();
          return;
        }
        if (!prepareCard(card, 0)) return;
        visualizer.resume().then(function () { return audio.play(); }).catch(function () {
          playerStatus.textContent = errorLabel;
          liveStatus.textContent = errorLabel + ": " + cardValue(card, "title");
          refreshPlaybackState();
        });
      });

      root.addEventListener("input", function (event) {
        var timeline = event.target.closest && event.target.closest("[data-dsiv-timeline]");
        if (!timeline || !root.contains(timeline)) return;
        var card = timeline.closest("[data-dsiv-track-card]");
        var requested = Number(timeline.value);
        if (!Number.isFinite(requested) || !prepareCard(card, requested)) return;
        updateCardProgress(card, requested);
      });

      function applyPendingSeek() {
        if (!activeCard || !Number.isFinite(audio.duration)) return false;
        var pending = Number(activeCard.dataset.dsivPendingSeek);
        if (!Number.isFinite(pending)) return false;
        var target = Math.min(Math.max(pending, 0), audio.duration);
        activeCard.dataset.dsivPendingSeek = String(target);
        try { audio.currentTime = target; } catch (error) { return false; }
        updateCardProgress(activeCard, target);
        return true;
      }

      audio.addEventListener("loadedmetadata", function () {
        if (!activeCard || !Number.isFinite(audio.duration)) return;
        activeCard.dataset.dsivDurationSeconds = String(audio.duration);
        if (!applyPendingSeek()) updateCardProgress(activeCard, audio.currentTime);
      });
      audio.addEventListener("canplay", applyPendingSeek);
      audio.addEventListener("seeked", function () {
        if (!activeCard) return;
        var pending = Number(activeCard.dataset.dsivPendingSeek);
        if (Number.isFinite(pending) && Math.abs(audio.currentTime - pending) <= 0.1) {
          delete activeCard.dataset.dsivPendingSeek;
        }
        updateCardProgress(activeCard, audio.currentTime);
      });
      audio.addEventListener("timeupdate", function () {
        if (!activeCard) return;
        var pending = Number(activeCard.dataset.dsivPendingSeek);
        if (Number.isFinite(pending) && Math.abs(audio.currentTime - pending) > 0.1) {
          if (!audio.seeking) applyPendingSeek();
          else updateCardProgress(activeCard, pending);
          return;
        }
        if (Number.isFinite(pending)) delete activeCard.dataset.dsivPendingSeek;
        updateCardProgress(activeCard, audio.currentTime);
      });
      audio.addEventListener("play", function () {
        refreshPlaybackState();
        liveStatus.textContent = playingLabel + ": " + cardValue(activeCard, "title");
        visualizer.draw();
      });
      audio.addEventListener("pause", function () {
        refreshPlaybackState();
        visualizer.draw();
      });
      audio.addEventListener("ended", function () {
        updateCardProgress(activeCard, 0);
        refreshPlaybackState();
      });
      audio.addEventListener("error", function () {
        if (playerStatus) playerStatus.textContent = errorLabel;
        if (liveStatus) liveStatus.textContent = errorLabel + (activeCard ? ": " + cardValue(activeCard, "title") : "");
        refreshPlaybackState();
      });

      function handleDiscoveryChange() {
        if (!indexReady) return;
        visibleLimit = pageSize;
        applyFilters();
      }

      [search, genre, license, key, preview, availability, sort].forEach(function (control) {
        if (!control) return;
        control.addEventListener("input", handleDiscoveryChange);
        control.addEventListener("change", handleDiscoveryChange);
      });
      if (albumNavigation) {
        albumNavigation.addEventListener("change", function () {
          if (albumNavigation.value) window.location.assign(albumNavigation.value);
        });
      }
      if (reset) {
        reset.addEventListener("click", function () {
          [search, genre, albumNavigation, license, key, preview, availability, sort].forEach(function (control) {
            if (!control) return;
            control.value = control === sort ? "recommended" : "";
          });
          visibleLimit = pageSize;
          applyFilters();
          if (search) search.focus();
        });
      }

      function pageUrl(pageNumber) {
        var url = new URL(window.location.href);
        url.searchParams.set("page", String(pageNumber));
        return url.toString();
      }

      function appendIndexedCards(html, pageNumber) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var sectionId = root.dataset.dsivCatalogSection || "";
        var fetchedRoot = Array.from(doc.querySelectorAll("[data-dsiv-catalog-section]")).find(function (candidate) {
          return !sectionId || candidate.dataset.dsivCatalogSection === sectionId;
        });
        if (!fetchedRoot) throw new Error("Catalog section missing from response");
        var fetchedTools = fetchedRoot.querySelector(".dsiv-collection-terminal__tools");
        if (!fetchedTools) throw new Error("Catalog page metadata missing from response");
        var fetchedPage = Number(fetchedTools.dataset.dsivCatalogCurrentPage || 0);
        var fetchedPages = Number(fetchedTools.dataset.dsivCatalogPageCount || 0);
        var fetchedTotal = Number(fetchedTools.dataset.dsivCatalogTotalItems || 0);
        if (fetchedPage !== pageNumber || fetchedPages !== totalPages || fetchedTotal !== totalItems) {
          throw new Error("Catalog page metadata did not match the request");
        }
        var nextCards = Array.from(fetchedRoot.querySelectorAll("[data-dsiv-track-card]"));
        var expectedCount = Math.min(pageSize, Math.max(0, totalItems - (pageNumber - 1) * pageSize));
        if (!nextCards.length || nextCards.length !== expectedCount) {
          throw new Error("Catalog page returned an unexpected card count");
        }
        var responseKeys = new Set();
        var addedCards = [];
        nextCards.forEach(function (card, index) {
          var identity = cardIdentity(card);
          if (!identity || responseKeys.has(identity) || cardKeys.has(identity)) {
            throw new Error("Catalog page returned a missing or duplicate card identity");
          }
          responseKeys.add(identity);
          setupCard(card, pageNumber, index);
          cards.push(card);
          addedCards.push(card);
        });
        return addedCards;
      }

      function nextUnloadedPage() {
        for (var page = 1; page <= totalPages; page += 1) {
          if (!indexedPages.has(page)) return page;
        }
        return 0;
      }

      function failToServerPagination() {
        pageLoadFailed = true;
        indexReady = false;
        cards = initialCards.slice();
        cardKeys = new Set(initialCards.map(cardIdentity));
        indexedPages = new Set([currentPage]);
        visibleLimit = pageSize;
        initialCards.forEach(function (card) { card.hidden = false; });
        grid.replaceChildren.apply(grid, initialCards);
        setDiscoveryDisabled(true);
        setFallbackPaginationVisible(true);
        if (loadMore) {
          loadMore.hidden = true;
          loadMore.disabled = true;
        }
        if (pagination) pagination.hidden = totalPages <= 1;
        if (empty) empty.hidden = true;
        if (count) {
          var label = initialCards.length === 1 ? singular : plural;
          count.textContent = totalItems > initialCards.length
            ? initialCards.length + " / " + totalItems + " " + label
            : initialCards.length + " " + label;
        }
        setIndexStatus(tools.dataset.dsivCatalogIndexFallback, false);
        return false;
      }

      function loadNextPage() {
        if (totalPages <= 1 || pageLoadFailed || destroyed) return Promise.resolve(false);
        if (!window.fetch) return Promise.resolve(failToServerPagination());
        if (activePageRequest) return activePageRequest;
        var pageNumber = nextUnloadedPage();
        if (!pageNumber) return Promise.resolve(false);
        setIndexStatus(tools.dataset.dsivCatalogIndexLoading, false);
        var requestOptions = { credentials: "same-origin" };
        if (abortController) requestOptions.signal = abortController.signal;
        activePageRequest = fetch(pageUrl(pageNumber), requestOptions).then(function (response) {
          if (!response.ok) throw new Error("Catalog page unavailable");
          return response.text();
        }).then(function (html) {
          if (destroyed) return false;
          appendIndexedCards(html, pageNumber);
          indexedPages.add(pageNumber);
          return true;
        }).catch(function (error) {
          if (destroyed || error && error.name === "AbortError") return false;
          return failToServerPagination();
        }).finally(function () {
          activePageRequest = null;
        });
        return activePageRequest;
      }

      function completeFullIndex() {
        if (cards.length !== totalItems || nextUnloadedPage()) {
          throw new Error("Catalog index did not contain every expected product");
        }
        indexReady = true;
        pageLoadFailed = false;
        refreshFilterOptions();
        setDiscoveryDisabled(false);
        setFallbackPaginationVisible(false);
        if (loadMore) loadMore.disabled = false;
        setIndexStatus(tools.dataset.dsivCatalogIndexReady, totalPages <= 1);
        applyFilters();
        return true;
      }

      function ensureFullIndex() {
        if (fullIndexRequest) return fullIndexRequest;
        function loadRemaining() {
          if (destroyed || pageLoadFailed) return Promise.resolve(false);
          if (!nextUnloadedPage()) {
            try {
              return Promise.resolve(completeFullIndex());
            } catch (error) {
              return Promise.resolve(failToServerPagination());
            }
          }
          return loadNextPage().then(function (loaded) {
            return loaded ? loadRemaining() : false;
          });
        }
        fullIndexRequest = loadRemaining().finally(function () {
          fullIndexRequest = null;
        });
        return fullIndexRequest;
      }

      if (indexReady) {
        completeFullIndex();
      } else {
        setDiscoveryDisabled(true);
        setFallbackPaginationVisible(true);
        if (loadMore) {
          loadMore.hidden = true;
          loadMore.disabled = true;
        }
        setIndexStatus(tools.dataset.dsivCatalogIndexLoading, false);
        applyFilters();
        window.setTimeout(function () {
          if (!destroyed) ensureFullIndex();
        }, 0);
      }
      if (loadMore) {
        loadMore.addEventListener("click", function () {
          if (!indexReady || pageLoadFailed) return;
          var previousState = applyFilters();
          var previouslyVisible = new Set(previousState.visibleCards);
          visibleLimit += pageSize;
          var state = applyFilters();
          var newlyVisible = state.visibleCards.find(function (card) { return !previouslyVisible.has(card); });
          if (newlyVisible) {
            var focusTarget = newlyVisible.querySelector("button:not([disabled]), a[href], input:not([disabled]), select:not([disabled])");
            if (focusTarget) focusTarget.focus();
          }
        });
      }

      function handleSectionUnload(event) {
        var boundary = event && event.target;
        if (!boundary || (boundary !== root && !(boundary.contains && boundary.contains(root)))) return;
        document.removeEventListener("shopify:section:unload", handleSectionUnload);
        destroyed = true;
        if (abortController) abortController.abort();
        audio.pause();
        visualizer.stop();
      }
      document.addEventListener("shopify:section:unload", handleSectionUnload);
    }

    function initAllCatalogSections(scope) {
      var rootScope = scope || document;
      if (rootScope.matches && rootScope.matches("[data-dsiv-catalog-section]")) initCatalogSection(rootScope);
      rootScope.querySelectorAll("[data-dsiv-catalog-section]").forEach(initCatalogSection);
    }

    initAllCatalogSections(document);
    document.addEventListener("shopify:section:load", function (event) { initAllCatalogSections(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-contact-terminal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-dsiv-contact-terminal]');
    const form = document.getElementById('DsivContactForm');
    if (!root || !form) return;

    const copySuccessMessage = root.dataset.dsivCopySuccessMessage || 'Brief copied.';
    const copyErrorMessage = root.dataset.dsivCopyErrorMessage || 'Copy did not complete.';
    const params = new URLSearchParams(window.location.search);
    const status = form.querySelector('[data-dsiv-copy-status]');
    const copyButton = form.querySelector('[data-dsiv-copy-request]');
    const selectByValue = (name, value) => {
      if (!value) return;

      const field = form.querySelector(`[name="${name}"]`);
      if (!field || !field.options) return;

      const match = Array.from(field.options).find((option) => option.value.toLowerCase() === value.toLowerCase());
      if (match) field.value = match.value;
    };

    selectByValue('contact[service_type]', params.get('service'));
    selectByValue('contact[budget]', params.get('budget'));
    selectByValue('contact[timeline]', params.get('timeline'));
    selectByValue('contact[intended_use]', params.get('intended_use'));

    const note = params.get('note') || params.get('notes');
    const body = form.querySelector('[name="contact[body]"]');
    if (note && body && !body.value.trim()) {
      body.value = note;
    }

    const deliverables = params.get('deliverables');
    const deliverablesField = form.querySelector('[name="contact[deliverables_needed]"]');
    if (deliverables && deliverablesField && !deliverablesField.value.trim()) {
      deliverablesField.value = deliverables;
    }

    const sourceUrl = form.querySelector('[data-dsiv-source-url-field]');
    if (sourceUrl) {
      sourceUrl.value = window.location.href;
    }

    const requestContext = form.querySelector('[data-dsiv-request-context]');
    const requestContextField = form.querySelector('[data-dsiv-request-context-field]');
    const contextTitle = form.querySelector('[data-dsiv-context-title]');
    const contextNote = form.querySelector('[data-dsiv-context-note]');
    const contextLabels = requestContext ? requestContext.dataset : {};

    const getFieldValue = (name) => {
      const field = form.querySelector(`[name="${name}"]`);
      return field ? field.value.trim() : '';
    };

    const syncRequestContext = () => {
      const service = getFieldValue('contact[service_type]');
      const budget = getFieldValue('contact[budget]');
      const timeline = getFieldValue('contact[timeline]');
      const intendedUse = getFieldValue('contact[intended_use]');
      const deliverablesValue = getFieldValue('contact[deliverables_needed]');
      const bodyValue = getFieldValue('contact[body]');
      const details = [];

      if (service) details.push(`${contextLabels.serviceLabel || 'Service type'}: ${service}`);
      if (budget) details.push(`${contextLabels.budgetLabel || 'Budget'}: ${budget}`);
      if (timeline) details.push(`${contextLabels.timelineLabel || 'Timeline'}: ${timeline}`);
      if (intendedUse) details.push(`${contextLabels.intendedUseLabel || 'Intended use'}: ${intendedUse}`);
      if (deliverablesValue) details.push(`${contextLabels.deliverablesLabel || 'Deliverables needed'}: ${deliverablesValue}`);
      if (bodyValue) details.push(`${contextLabels.noteLabel || 'Project notes'}: ${bodyValue}`);

      if (requestContextField) {
        requestContextField.value = details.join('\n');
      }
    };

    const buildRequestSummary = () => {
      syncRequestContext();

      const lines = [
        'DSIV Project Request',
        '',
        `Name: ${getFieldValue('contact[name]')}`,
        `Email: ${getFieldValue('contact[email]')}`,
        `Phone: ${getFieldValue('contact[phone]')}`,
        `Service type: ${getFieldValue('contact[service_type]')}`,
        `Budget: ${getFieldValue('contact[budget]')}`,
        `Timeline: ${getFieldValue('contact[timeline]')}`,
        `Intended use: ${getFieldValue('contact[intended_use]')}`,
        `Project link: ${getFieldValue('contact[project_link]')}`,
        '',
        'Deliverables needed:',
        getFieldValue('contact[deliverables_needed]'),
        '',
        'Project notes:',
        getFieldValue('contact[body]'),
        '',
        `Source URL: ${window.location.href}`,
      ];

      return lines.join('\n');
    };

    const setStatus = (message) => {
      if (!status) return;
      status.textContent = message;
      status.hidden = false;
      status.focus();
    };

    const showHandoffContext = () => {
      if (!requestContext || !contextTitle) return;

      const service = getFieldValue('contact[service_type]');
      const budget = getFieldValue('contact[budget]');
      const timeline = getFieldValue('contact[timeline]');
      const intendedUse = getFieldValue('contact[intended_use]');
      const summary = [service, budget, timeline, intendedUse].filter(Boolean).join(' / ');

      if (!summary && !note && !deliverables) return;

      contextTitle.textContent = summary || note || deliverables;
      if (contextNote) {
        contextNote.textContent = [deliverables, note].filter(Boolean).join(' / ');
        contextNote.hidden = !contextNote.textContent;
      }
      requestContext.hidden = false;
    };

    ['contact[service_type]', 'contact[budget]', 'contact[timeline]', 'contact[intended_use]', 'contact[deliverables_needed]', 'contact[body]'].forEach((name) => {
      const field = form.querySelector(`[name="${name}"]`);
      if (field) {
        field.addEventListener('change', syncRequestContext);
        field.addEventListener('input', syncRequestContext);
      }
    });

    syncRequestContext();
    showHandoffContext();
    form.addEventListener('submit', () => {
      syncRequestContext();
    });

    if (copyButton) {
      copyButton.addEventListener('click', async () => {
        const summary = buildRequestSummary();
        try {
          await navigator.clipboard.writeText(summary);
          setStatus(copySuccessMessage);
        } catch (error) {
          setStatus(copyErrorMessage);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-drop-collection-terminal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-dsiv-drop-collection]').forEach((root) => {
      if (root.dataset.dropCollectionReady === 'true') return;
      root.dataset.dropCollectionReady = 'true';

      const grid = root.querySelector('[data-drop-grid]');
      if (!grid) return;

      const cards = Array.from(grid.querySelectorAll('[data-drop-card]'));
      const search = root.querySelector('[data-drop-search]');
      const availability = root.querySelector('[data-drop-availability]');
      const sort = root.querySelector('[data-drop-sort]');
      const count = root.querySelector('[data-drop-count]');
      const noResults = root.querySelector('[data-drop-no-results]');

      const refresh = () => {
        const query = (search?.value || '').trim().toLowerCase();
        const selectedAvailability = availability?.value || 'all';
        let visible = 0;

        cards.forEach((card) => {
          const matchesSearch = !query || card.dataset.search.includes(query);
          const matchesAvailability = selectedAvailability === 'all' || card.dataset.availability === selectedAvailability;
          card.hidden = !(matchesSearch && matchesAvailability);
          if (!card.hidden) visible += 1;
        });

        const label = visible === 1 ? root.dataset.countSingular : root.dataset.countPlural;
        if (count) count.textContent = `${visible} ${label}`;
        if (noResults) noResults.hidden = visible !== 0;
      };

      const applySort = () => {
        const mode = sort?.value || 'recommended';
        const ordered = [...cards].sort((left, right) => {
          if (mode === 'title-asc') return left.dataset.title.localeCompare(right.dataset.title);
          if (mode === 'price-asc') return Number(left.dataset.price) - Number(right.dataset.price);
          if (mode === 'price-desc') return Number(right.dataset.price) - Number(left.dataset.price);
          return Number(left.dataset.index) - Number(right.dataset.index);
        });
        ordered.forEach((card) => grid.appendChild(card));
        refresh();
      };

      search?.addEventListener('input', refresh);
      availability?.addEventListener('change', refresh);
      sort?.addEventListener('change', applySort);
      refresh();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-drops-terminal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRegistry = (root) => {
      const stage = root.querySelector('[data-dsiv-drop-registry]');
      const canvas = root.querySelector('[data-dsiv-drop-canvas]');
      if (!stage || !canvas || canvas.dataset.ready === 'true') return;
      canvas.dataset.ready = 'true';
      const gl = canvas.getContext('webgl', { alpha: true, antialias: false, depth: false });
      if (!gl) {
        canvas.hidden = true;
        return;
      }

      const vertexSource = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';
      const fragmentSource = `
        precision mediump float;
        uniform vec2 r;
        uniform float t;
        float ring(vec2 p,float radius,float width){return 1.0-smoothstep(width,width+0.004,abs(length(p)-radius));}
        void main(){
          vec2 uv=gl_FragCoord.xy/r;
          vec2 p=(gl_FragCoord.xy-.5*r)/min(r.x,r.y);
          float gridX=1.0-smoothstep(0.0,0.012,abs(fract(uv.x*9.0)-0.5));
          float gridY=1.0-smoothstep(0.0,0.012,abs(fract(uv.y*7.0)-0.5));
          float registry=(gridX+gridY)*0.05;
          float outer=ring(p,0.31,0.008);
          float inner=ring(p,0.19,0.006);
          float sweep=atan(p.y,p.x)+t*0.38;
          float signal=smoothstep(0.94,1.0,cos(sweep))*exp(-abs(length(p)-0.31)*95.0);
          float unique=exp(-length(p-vec2(cos(t*0.28),sin(t*0.28))*0.19)*48.0);
          vec3 cobalt=vec3(0.106,0.341,0.839);
          vec3 ice=vec3(0.72,0.82,1.0);
          vec3 color=cobalt*(registry+outer*0.25+inner*0.18)+ice*(signal*0.72+unique*0.5);
          gl_FragColor=vec4(color,clamp(registry+outer*0.28+inner*0.2+signal*0.75+unique*0.56,0.0,0.82));
        }`;

      const compile = (type, source) => {
        const shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) return null;
        return shader;
      };

      const vertex = compile(gl.VERTEX_SHADER, vertexSource);
      const fragment = compile(gl.FRAGMENT_SHADER, fragmentSource);
      if (!vertex || !fragment) {
        canvas.hidden = true;
        return;
      }

      const program = gl.createProgram();
      gl.attachShader(program, vertex);
      gl.attachShader(program, fragment);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        canvas.hidden = true;
        return;
      }

      const buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]), gl.STATIC_DRAW);
      gl.useProgram(program);
      const position = gl.getAttribLocation(program, 'a');
      const resolution = gl.getUniformLocation(program, 'r');
      const time = gl.getUniformLocation(program, 't');
      gl.enableVertexAttribArray(position);
      gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const start = performance.now();
      let frame = 0;
      let visible = true;

      const draw = (now) => {
        const ratio = Math.min(devicePixelRatio || 1, 1.5);
        const width = Math.max(1, Math.round(stage.clientWidth * ratio));
        const height = Math.max(1, Math.round(stage.clientHeight * ratio));
        if (canvas.width !== width || canvas.height !== height) {
          canvas.width = width;
          canvas.height = height;
          gl.viewport(0, 0, width, height);
        }
        gl.uniform2f(resolution, width, height);
        gl.uniform1f(time, reduced ? 2.8 : (now - start) / 1000);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
        if (!reduced && visible && !document.hidden) frame = requestAnimationFrame(draw);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          visible = Boolean(entries[0] && entries[0].isIntersecting);
          cancelAnimationFrame(frame);
          if (visible) frame = requestAnimationFrame(draw);
        }, { threshold: 0.05 });
        observer.observe(stage);
      }

      draw(performance.now());
    };

    const initReveals = (root) => {
      const items = Array.from(root.querySelectorAll('[data-dsiv-drop-reveal]'));
      if (!items.length) return;
      items.forEach((item, index) => item.style.setProperty('--dsiv-drop-delay', `${Math.min(index % 4, 3) * 55}ms`));
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-revealed'));
        return;
      }
      root.classList.add('is-reveal-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      items.forEach((item) => observer.observe(item));
    };

    const init = (scope = document) => {
      scope.querySelectorAll('[data-dsiv-drops]').forEach((root) => {
        if (root.dataset.ready === 'true') return;
        root.dataset.ready = 'true';
        initRegistry(root);
        initReveals(root);
        window.lucide?.createIcons({ attrs: { 'aria-hidden': 'true' } });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    window.addEventListener('load', () => window.lucide?.createIcons({ attrs: { 'aria-hidden': 'true' } }), { once: true });
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-product-license-terminal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let activeAudio = null;
    let sharedAudioContext = null;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const formatPreviewTime = (seconds) => {
      if (!Number.isFinite(seconds)) return '0:00';
      const safeSeconds = Math.max(0, Math.floor(seconds));
      const minutes = Math.floor(safeSeconds / 60);
      const remainder = String(safeSeconds % 60).padStart(2, '0');
      return `${minutes}:${remainder}`;
    };

    const setPreviewState = (preview, state) => {
      const audio = preview.querySelector('[data-dsiv-product-audio]');
      const button = preview.querySelector('[data-dsiv-product-audio-toggle]');
      const buttonLabel = preview.querySelector('[data-dsiv-product-audio-button-label]');
      const status = preview.querySelector('[data-dsiv-product-audio-status]');
      const time = preview.querySelector('[data-dsiv-product-audio-time]');
      const duration = preview.querySelector('[data-dsiv-product-audio-duration]');
      const timeline = preview.querySelector('[data-dsiv-product-audio-timeline]');
      const isPlaying = state === 'playing';

      if (button) {
        const label = isPlaying ? button.dataset.pauseLabel : button.dataset.playLabel;
        const trackTitle = preview.dataset.trackTitle || '';
        const ariaLabel = trackTitle ? `${label} ${trackTitle}` : label;
        button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
        button.setAttribute('aria-label', ariaLabel || '');
        if (buttonLabel && label) buttonLabel.textContent = label;
      }

      if (status) {
        if (state === 'error') {
          status.textContent = preview.dataset.previewError || 'Preview unavailable';
        } else if (isPlaying) {
          status.textContent = preview.dataset.previewPlaying || 'Playing preview';
        } else {
          status.textContent = preview.dataset.previewReady || 'Preview ready';
        }
      }

      if (time && audio) {
        const value = formatPreviewTime(audio.currentTime);
        time.textContent = value;
        time.setAttribute('datetime', `PT${Math.max(0, Math.floor(audio.currentTime || 0))}S`);
      }

      if (duration && audio && Number.isFinite(audio.duration)) {
        const value = formatPreviewTime(audio.duration);
        duration.textContent = value;
        duration.setAttribute('datetime', `PT${Math.max(0, Math.floor(audio.duration))}S`);
      }

      if (timeline && audio) {
        const maximum = Number.isFinite(audio.duration) && audio.duration > 0 ? audio.duration : 100;
        const current = Math.min(maximum, Math.max(0, audio.currentTime || 0));
        timeline.min = '0';
        timeline.max = String(maximum);
        timeline.value = String(current);
        timeline.setAttribute('aria-valuemin', '0');
        timeline.setAttribute('aria-valuemax', String(maximum));
        timeline.setAttribute('aria-valuenow', String(current));
        timeline.setAttribute('aria-valuetext', `${formatPreviewTime(current)} / ${formatPreviewTime(maximum)}`);
      }
    };

    const createVisualizer = (canvas, analyser) => {
      const gl = canvas && canvas.getContext && canvas.getContext('webgl', { alpha: true, antialias: false });
      if (!gl) return null;

      const data = new Uint8Array(analyser.frequencyBinCount);
      const bars = 36;

      const resize = () => {
        const rect = canvas.getBoundingClientRect();
        const scale = Math.min(window.devicePixelRatio || 1, 2);
        const width = Math.max(1, Math.floor(rect.width * scale));
        const height = Math.max(1, Math.floor(rect.height * scale));
        if (canvas.width !== width || canvas.height !== height) {
          canvas.width = width;
          canvas.height = height;
        }
      };

      const render = (active) => {
        resize();
        if (active) analyser.getByteFrequencyData(data);

        const width = canvas.width;
        const height = canvas.height;
        gl.viewport(0, 0, width, height);
        gl.disable(gl.SCISSOR_TEST);
        gl.clearColor(0.012, 0.02, 0.04, 0.72);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.enable(gl.SCISSOR_TEST);

        const gap = Math.max(2, Math.floor(width * 0.006));
        const barWidth = Math.max(2, Math.floor((width - gap * (bars - 1)) / bars));

        for (let index = 0; index < bars; index += 1) {
          const dataIndex = Math.min(data.length - 1, Math.floor((index / bars) * data.length));
          const idle = 38 + Math.sin(Date.now() / 360 + index * 0.72) * 22;
          const value = active ? data[dataIndex] : idle;
          const normalized = Math.max(0.06, Math.min(1, value / 255));
          const barHeight = Math.max(4, Math.floor(height * normalized));
          const x = index * (barWidth + gap);
          const y = Math.max(0, Math.floor((height - barHeight) * 0.58));

          gl.scissor(x, y, barWidth, barHeight);
          gl.clearColor(0.1 + normalized * 0.22, 0.34 + normalized * 0.32, 0.82, 0.72);
          gl.clear(gl.COLOR_BUFFER_BIT);

          gl.scissor(x, Math.min(height - 1, y + barHeight - 2), barWidth, Math.min(3, barHeight));
          gl.clearColor(0.9, 0.72, 0.28, 0.88);
          gl.clear(gl.COLOR_BUFFER_BIT);
        }

        gl.disable(gl.SCISSOR_TEST);
      };

      return { render };
    };

    const connectAudioGraph = (audio, preview) => {
      if (audio.dsivProductPreviewGraph !== undefined) return audio.dsivProductPreviewGraph;

      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) {
          audio.dsivProductPreviewGraph = null;
          return null;
        }

        sharedAudioContext = sharedAudioContext || new AudioContext();
        const analyser = sharedAudioContext.createAnalyser();
        analyser.fftSize = 128;
        analyser.smoothingTimeConstant = 0.76;

        const source = audio.dsivProductPreviewSource || sharedAudioContext.createMediaElementSource(audio);
        audio.dsivProductPreviewSource = source;
        source.connect(analyser);
        analyser.connect(sharedAudioContext.destination);

        const canvas = preview.querySelector('[data-dsiv-product-audio-visualizer] canvas');
        audio.dsivProductPreviewGraph = {
          context: sharedAudioContext,
          visualizer: createVisualizer(canvas, analyser)
        };
      } catch (error) {
        audio.dsivProductPreviewGraph = null;
      }

      return audio.dsivProductPreviewGraph;
    };

    const renderPreview = (preview, audio) => {
      const graph = audio.dsivProductPreviewGraph || null;
      const visualizer = graph && graph.visualizer ? graph.visualizer : null;
      if (visualizer) visualizer.render(!audio.paused && !audio.ended);
      if (!prefersReducedMotion && !audio.paused && !audio.ended) {
        window.cancelAnimationFrame(audio.dsivProductPreviewFrame || 0);
        audio.dsivProductPreviewFrame = window.requestAnimationFrame(() => {
          renderPreview(preview, audio);
        });
      }
    };

    const setupAudioPreview = (section) => {
      const preview = section.querySelector('[data-dsiv-product-audio-preview]');
      if (!preview || preview.dataset.dsivPreviewReady === 'true') return;

      const audio = preview.querySelector('[data-dsiv-product-audio]');
      const button = preview.querySelector('[data-dsiv-product-audio-toggle]');
      const timeline = preview.querySelector('[data-dsiv-product-audio-timeline]');
      if (!audio || !button) return;

      preview.dataset.dsivPreviewReady = 'true';
      preview.classList.add('is-enhanced');
      audio.controls = false;
      audio.tabIndex = -1;
      audio.setAttribute('aria-hidden', 'true');

      audio.addEventListener('loadedmetadata', () => setPreviewState(preview, audio.paused ? 'ready' : 'playing'));
      audio.addEventListener('timeupdate', () => setPreviewState(preview, audio.paused ? 'ready' : 'playing'));
      audio.addEventListener('play', () => {
        setPreviewState(preview, 'playing');
        renderPreview(preview, audio);
      });
      audio.addEventListener('pause', () => {
        setPreviewState(preview, 'ready');
        renderPreview(preview, audio);
      });
      audio.addEventListener('ended', () => {
        setPreviewState(preview, 'ready');
        renderPreview(preview, audio);
      });
      audio.addEventListener('error', () => setPreviewState(preview, 'error'));

      if (timeline) {
        timeline.addEventListener('input', () => {
          const requestedTime = Number(timeline.value);
          if (Number.isFinite(requestedTime)) audio.currentTime = requestedTime;
          setPreviewState(preview, audio.paused ? 'ready' : 'playing');
        });
      }

      button.addEventListener('click', async () => {
        const graph = connectAudioGraph(audio, preview);
        if (graph && graph.context && graph.context.state === 'suspended') {
          await graph.context.resume();
        }

        if (activeAudio && activeAudio !== audio) activeAudio.pause();

        if (audio.paused || audio.ended) {
          try {
            await audio.play();
            activeAudio = audio;
            setPreviewState(preview, 'playing');
            renderPreview(preview, audio);
          } catch (error) {
            setPreviewState(preview, 'error');
          }
        } else {
          audio.pause();
        }
      });

      setPreviewState(preview, 'ready');
    };

    const setupVariantSelect = (section) => {
      const select = section.querySelector('[data-dsiv-variant-select]');
      if (!select) return;

      const price = section.querySelector('[data-dsiv-product-price]');
      const button = section.querySelector('[data-dsiv-add-button]');

      const syncVariant = () => {
        const option = select.options[select.selectedIndex];
        if (!option) return;

        if (price && option.dataset.price) {
          price.textContent = option.dataset.price;
        }

        if (button) {
          const isAvailable = option.dataset.available === 'true';
          button.disabled = !isAvailable;
          button.textContent = isAvailable ? button.dataset.addLabel : button.dataset.soldLabel;
        }
      };

      select.addEventListener('change', syncVariant);
      syncVariant();
    };

    document.querySelectorAll('.dsiv-product-terminal').forEach((section) => {
      setupVariantSelect(section);
      setupAudioPreview(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-resources-terminal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setupIcons = (root) => {
      if (window.lucide && typeof window.lucide.createIcons === 'function') {
        window.lucide.createIcons({ root });
      }
    };

    const setupReveal = (root) => {
      const items = Array.from(root.querySelectorAll('[data-dsiv-resources-reveal]'));
      if (!items.length || reducedMotion.matches || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-revealed'));
        return null;
      }

      root.classList.add('is-reveal-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

      items.forEach((item, index) => {
        item.style.setProperty('--dsiv-reveal-delay', `${Math.min(index % 3, 2) * 70}ms`);
        observer.observe(item);
      });

      return observer;
    };

    const setupWorkflowCanvas = (root) => {
      const stage = root.querySelector('[data-dsiv-resources-stage]');
      const canvas = root.querySelector('[data-dsiv-resources-canvas]');
      const fallback = root.querySelector('[data-dsiv-resources-fallback]');
      if (!stage || !canvas) return null;

      const context = canvas.getContext('2d');
      if (!context) {
        canvas.hidden = true;
        if (fallback) fallback.style.display = 'block';
        return null;
      }

      let frameId = 0;
      let visible = true;
      let width = 0;
      let height = 0;
      let startTime = performance.now();

      const resize = () => {
        const rect = stage.getBoundingClientRect();
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        width = Math.max(1, Math.round(rect.width));
        height = Math.max(1, Math.round(rect.height));
        canvas.width = Math.round(width * ratio);
        canvas.height = Math.round(height * ratio);
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        context.setTransform(ratio, 0, 0, ratio, 0, 0);
        stop();
        draw(performance.now(), false);
        start();
      };

      const draw = (time, scheduleNext = true) => {
        frameId = 0;
        context.clearRect(0, 0, width, height);
        const compact = width < 520;
        const nodes = compact
          ? [[0.25, 0.22], [0.75, 0.22], [0.25, 0.72], [0.75, 0.72]]
          : [[0.125, 0.38], [0.375, 0.38], [0.625, 0.38], [0.875, 0.38]];

        context.lineWidth = 1;
        context.strokeStyle = 'rgba(143, 180, 255, 0.42)';
        context.beginPath();
        nodes.forEach((node, index) => {
          const x = node[0] * width;
          const y = node[1] * height;
          if (index === 0) context.moveTo(x, y);
          else context.lineTo(x, y);
        });
        context.stroke();

        const elapsed = reducedMotion.matches ? 0.62 : (Math.max(0, time - startTime) / 5600) % 1;
        const segmentCount = nodes.length - 1;
        const scaled = elapsed * segmentCount;
        const segmentIndex = Math.max(0, Math.min(segmentCount - 1, Math.floor(scaled)));
        const segmentProgress = scaled - segmentIndex;
        const from = nodes[segmentIndex];
        const to = nodes[segmentIndex + 1];
        const pulseX = (from[0] + (to[0] - from[0]) * segmentProgress) * width;
        const pulseY = (from[1] + (to[1] - from[1]) * segmentProgress) * height;

        nodes.forEach((node, index) => {
          const x = node[0] * width;
          const y = node[1] * height;
          context.beginPath();
          context.arc(x, y, index === segmentIndex + 1 ? 8 : 6, 0, Math.PI * 2);
          context.fillStyle = index <= segmentIndex ? '#8fb4ff' : '#ffffff';
          context.fill();
          context.lineWidth = 2;
          context.strokeStyle = '#1b57d6';
          context.stroke();
        });

        context.beginPath();
        context.arc(pulseX, pulseY, 5, 0, Math.PI * 2);
        context.fillStyle = '#ffffff';
        context.fill();

        if (scheduleNext && !reducedMotion.matches && visible && !document.hidden) {
          frameId = requestAnimationFrame(draw);
        }
      };

      const start = () => {
        if (frameId || reducedMotion.matches || !visible || document.hidden) return;
        startTime = performance.now();
        frameId = requestAnimationFrame(draw);
      };

      const stop = () => {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = 0;
      };

      const visibilityObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            visible = entries[0] ? entries[0].isIntersecting : true;
            if (visible) start();
            else stop();
          }, { threshold: 0.05 })
        : null;

      if (visibilityObserver) visibilityObserver.observe(stage);

      const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(resize) : null;
      if (resizeObserver) resizeObserver.observe(stage);
      else window.addEventListener('resize', resize, { passive: true });

      const handleVisibility = () => {
        if (document.hidden) stop();
        else start();
      };
      document.addEventListener('visibilitychange', handleVisibility);
      resize();
      if (reducedMotion.matches) draw(performance.now(), false);
      else start();

      return () => {
        stop();
        if (visibilityObserver) visibilityObserver.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        else window.removeEventListener('resize', resize);
        document.removeEventListener('visibilitychange', handleVisibility);
      };
    };

    const setup = (root) => {
      if (!root || root.dataset.dsivResourcesReady === 'true') return;
      root.dataset.dsivResourcesReady = 'true';
      setupIcons(root);
      root.dsivResourcesRevealObserver = setupReveal(root);
      root.dsivResourcesCanvasDestroy = setupWorkflowCanvas(root);
      const standaloneStage = document.querySelector('[data-dsiv-webgl-stage]');
      if (standaloneStage && !root.contains(standaloneStage)) {
        const stageWrapper = standaloneStage.closest('.shopify-section');
        root.dsivResourcesStandaloneStage = stageWrapper || standaloneStage;
        root.dsivResourcesStandaloneStage.hidden = true;
      }
    };

    document.querySelectorAll('[data-dsiv-resources]').forEach(setup);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-dsiv-resources]');
      setup(root);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector('[data-dsiv-resources]');
      if (!root) return;
      if (root.dsivResourcesRevealObserver) root.dsivResourcesRevealObserver.disconnect();
      if (typeof root.dsivResourcesCanvasDestroy === 'function') root.dsivResourcesCanvasDestroy();
      if (root.dsivResourcesStandaloneStage) root.dsivResourcesStandaloneStage.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-site-chrome"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const placeHeaderBeforeMain = () => {
      const main = document.getElementById('MainContent');
      const header = document.querySelector('.dsiv-site-chrome--header');
      const wrapper = header?.closest('.shopify-section') || header;
      if (!main || !wrapper || !main.contains(wrapper)) return;
      main.before(wrapper);
    };

    const removeLegacyDsivCursor = () => {
      document.querySelectorAll("#logo-cursor, .cursor-trail").forEach((element) => element.remove());
    };

    placeHeaderBeforeMain();
    removeLegacyDsivCursor();
    document.addEventListener("DOMContentLoaded", removeLegacyDsivCursor, { once: true });
    window.setTimeout(removeLegacyDsivCursor, 1200);

    document.querySelectorAll('.dsiv-site-chrome__mobile-menu').forEach((menu) => {
      const summary = menu.querySelector('summary');
      const updateExpandedState = () => {
        summary?.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
      };

      updateExpandedState();
      menu.addEventListener('toggle', updateExpandedState);

      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
        menu.removeAttribute('open');
      }));

      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        menu.removeAttribute('open');
        summary?.focus();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-terminal-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatTime = (seconds) => {
      const safe = Number.isFinite(seconds) ? Math.max(0, seconds) : 0;
      return `${Math.floor(safe / 60)}:${String(Math.floor(safe % 60)).padStart(2, '0')}`;
    };

    const initHero = (root) => {
      const hero = root.querySelector('[data-dsiv-home-hero]');
      const canvas = root.querySelector('[data-dsiv-home-hero-fx]');
      if (!hero || !canvas || canvas.dataset.ready === 'true') return;
      canvas.dataset.ready = 'true';
      const gl = canvas.getContext('webgl', { alpha: true, antialias: false, depth: false });
      if (!gl) { canvas.hidden = true; return; }

      const vertexSource = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';
      const fragmentSource = `
        precision highp float;
        uniform vec2 r;
        uniform float t;
        float glow(float d,float w){return w/max(abs(d),.001);}
        void main(){
          vec2 uv=gl_FragCoord.xy/r.xy;
          float mask=smoothstep(.34,.58,uv.x);
          float y=.55+sin(uv.x*31.-t*2.15)*.014+sin(uv.x*67.+t*1.35)*.006;
          float wave=glow(uv.y-y,.0018)*mask;
          float scan=exp(-pow((uv.x-fract(t*.055+.35))*34.,2.))*mask;
          vec2 p=vec2(.69,.31);
          float d=length((uv-p)*vec2(r.x/r.y,1.));
          float orb=exp(-pow((d-.075)*36.,2.))*(.62+.38*sin(t*.8));
          vec3 cobalt=vec3(.106,.341,.839);
          vec3 ice=vec3(.62,.82,1.);
          vec3 color=cobalt*wave*.06+ice*scan*.11+ice*orb*.09;
          float alpha=clamp(wave*.024+scan*.1+orb*.07,0.,.38);
          gl_FragColor=vec4(color,alpha);
        }`;

      const compile = (type, source) => {
        const shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) return null;
        return shader;
      };
      const vertex = compile(gl.VERTEX_SHADER, vertexSource);
      const fragment = compile(gl.FRAGMENT_SHADER, fragmentSource);
      if (!vertex || !fragment) { canvas.hidden = true; return; }
      const program = gl.createProgram();
      gl.attachShader(program, vertex);
      gl.attachShader(program, fragment);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) { canvas.hidden = true; return; }
      const buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]), gl.STATIC_DRAW);
      gl.useProgram(program);
      const position = gl.getAttribLocation(program, 'a');
      const resolution = gl.getUniformLocation(program, 'r');
      const time = gl.getUniformLocation(program, 't');
      gl.enableVertexAttribArray(position);
      gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
      let frame = 0;
      let visible = true;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const start = performance.now();
      const draw = (now) => {
        const ratio = Math.min(devicePixelRatio || 1, 1.5);
        const width = Math.max(1, Math.round(hero.clientWidth * ratio));
        const height = Math.max(1, Math.round(hero.clientHeight * ratio));
        if (canvas.width !== width || canvas.height !== height) { canvas.width = width; canvas.height = height; gl.viewport(0, 0, width, height); }
        gl.uniform2f(resolution, width, height);
        gl.uniform1f(time, reduced ? 2.4 : (now - start) / 1000);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
        if (!reduced && visible && !document.hidden) frame = requestAnimationFrame(draw);
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          visible = Boolean(entries[0]?.isIntersecting);
          cancelAnimationFrame(frame);
          if (visible) frame = requestAnimationFrame(draw);
        }, { threshold: 0.05 });
        observer.observe(hero);
      }
      draw(performance.now());
    };

    const initReveals = (root) => {
      const items = [...root.querySelectorAll('[data-dsiv-reveal]')];
      if (!items.length) return;
      items.forEach((item, index) => item.style.setProperty('--dsiv-reveal-delay', `${Math.min(index % 5, 4) * 45}ms`));
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-revealed'));
        return;
      }
      root.classList.add('is-reveal-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          entry.target.addEventListener('transitionend', () => {
            entry.target.style.willChange = 'auto';
          }, { once: true });
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });
      items.forEach((item) => observer.observe(item));
    };

    const initHeroAudio = (root) => {
      const control = root.querySelector('[data-dsiv-home-hero-audio]');
      const audio = control?.querySelector('[data-dsiv-home-hero-track]');
      const button = control?.querySelector('[data-dsiv-home-hero-audio-toggle]');
      const label = control?.querySelector('[data-dsiv-home-hero-audio-label]');
      const video = root.querySelector('[data-dsiv-video-stage-media]');
      const hero = root.querySelector('[data-dsiv-home-hero]');
      const catalogAudio = root.querySelector('[data-dsiv-home-audio]');
      if (!control || !audio || !button || !label || control.dataset.ready === 'true') return;
      control.dataset.ready = 'true';

      const update = (playing) => {
        const text = playing ? 'Pause "Ata Ata Ata"' : 'Play "Ata Ata Ata"';
        label.textContent = text;
        button.setAttribute('aria-label', text);
        button.setAttribute('aria-pressed', String(playing));
        control.classList.toggle('is-playing', playing);
      };

      const stop = (reset = false) => {
        audio.pause();
        if (reset) audio.currentTime = 0;
        update(false);
      };

      button.addEventListener('click', async () => {
        if (!audio.paused) {
          stop();
          return;
        }

        document.querySelectorAll('audio').forEach((otherAudio) => {
          if (otherAudio !== audio) otherAudio.pause();
        });

        audio.currentTime = 0;
        if (video && getComputedStyle(video).display !== 'none' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.pause();
          video.currentTime = 0;
          video.play().catch(() => {});
        }

        try {
          await audio.play();
        } catch (error) {
          stop(true);
        }
      });

      audio.addEventListener('play', () => update(true));
      audio.addEventListener('pause', () => update(false));
      audio.addEventListener('ended', () => {
        stop(true);
        if (video && getComputedStyle(video).display !== 'none' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.currentTime = 0;
          video.play().catch(() => {});
        }
      });
      catalogAudio?.addEventListener('play', () => stop());
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
      });

      if (hero && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0]?.isIntersecting) stop();
        }, { threshold: 0.1 });
        observer.observe(hero);
      }

      update(false);
    };

    const initCatalog = (root) => {
      const audio = root.querySelector('[data-dsiv-home-audio]');
      if (!audio) return;
      const rows = [...root.querySelectorAll('[data-dsiv-home-track]')];
      const buttons = [...root.querySelectorAll('[data-dsiv-home-play]')];
      const search = root.querySelector('[data-dsiv-home-search]');
      const filters = [...root.querySelectorAll('[data-dsiv-home-filter]')];
      const count = root.querySelector('[data-dsiv-home-count]');
      const empty = root.querySelector('[data-dsiv-home-empty]');
      const live = root.querySelector('[data-dsiv-home-live]');
      const player = root.querySelector('[data-dsiv-home-player]');
      const playerTitle = root.querySelector('[data-dsiv-home-player-title]');
      const playerStatus = root.querySelector('[data-dsiv-home-player-status]');
      const playerCanvas = root.querySelector('[data-dsiv-home-player-canvas]');
      const playerToggle = root.querySelector('[data-dsiv-home-player-toggle]');
      const playerToggleLabel = root.querySelector('[data-dsiv-home-player-button-label]');
      let activeRow = null;
      let activeFilter = 'all';
      let audioContext;
      let analyser;
      let frequencyData;
      let sourceNode;
      let visualFrame = 0;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

      const announce = (message) => { if (live) live.textContent = message; };
      const updateCount = () => {
        if (!count) return;
        const visible = rows.filter((row) => !row.hidden).length;
        count.textContent = `${visible} ${visible === 1 ? root.dataset.countSingular : root.dataset.countPlural}`;
        if (empty) empty.hidden = visible !== 0;
      };
      const applyFilters = () => {
        const query = (search?.value || '').trim().toLowerCase();
        rows.forEach((row) => {
          const matchesQuery = !query || row.dataset.search.includes(query);
          const matchesFilter = activeFilter === 'all' || (activeFilter === 'preview' && row.dataset.preview) || (activeFilter === 'available' && row.dataset.available === 'true');
          row.hidden = !(matchesQuery && matchesFilter);
        });
        if (activeRow?.hidden && !audio.paused) {
          audio.pause();
          announce(`${root.dataset.previewReady}: ${activeRow.dataset.title}`);
        }
        updateCount();
      };

      const updateButtons = () => {
        const playing = !audio.paused && !audio.ended;
        buttons.forEach((button) => {
          const row = button.closest('[data-dsiv-home-track]');
          const isPlaying = playing && row === activeRow;
          const label = isPlaying ? button.dataset.pauseLabel : button.dataset.playLabel;
          button.setAttribute('aria-label', `${label} ${row.dataset.title}`);
          button.setAttribute('aria-pressed', String(isPlaying));
          button.innerHTML = `<i data-lucide="${isPlaying ? 'pause' : 'play'}" aria-hidden="true"></i>`;
          row.classList.toggle('is-playing', isPlaying);
        });
        if (playerToggle && activeRow) {
          const label = playing ? playerToggle.dataset.pauseLabel : playerToggle.dataset.playLabel;
          playerToggle.setAttribute('aria-label', `${label} ${activeRow.dataset.title}`);
          playerToggle.setAttribute('aria-pressed', String(playing));
          if (playerToggleLabel) playerToggleLabel.textContent = label;
          const iconHost = playerToggle.querySelector('[data-dsiv-home-player-icon]');
          if (iconHost) {
            const icon = document.createElement('i');
            icon.setAttribute('data-lucide', playing ? 'pause' : 'play');
            iconHost.replaceChildren(icon);
          }
        }
        window.lucide?.createIcons({ attrs: { 'aria-hidden': 'true' } });
      };

      const updateProgress = () => {
        if (!activeRow) return;
        const duration = Number.isFinite(audio.duration) ? audio.duration : 0;
        const progress = duration ? audio.currentTime / duration * 100 : 0;
        const waveform = activeRow.querySelector('.dsiv-home__waveform');
        const timeline = activeRow.querySelector('[data-dsiv-home-timeline]');
        const status = activeRow.querySelector('[data-dsiv-home-row-status]');
        waveform?.style.setProperty('--progress', `${progress}%`);
        if (timeline) {
          const maximum = duration || 100;
          const current = Math.min(maximum, Math.max(0, audio.currentTime || 0));
          timeline.min = '0';
          timeline.max = maximum;
          timeline.value = current;
          timeline.setAttribute('aria-valuemin', '0');
          timeline.setAttribute('aria-valuemax', String(maximum));
          timeline.setAttribute('aria-valuenow', String(current));
          timeline.setAttribute('aria-valuetext', `${formatTime(audio.currentTime)} / ${formatTime(duration)}`);
        }
        if (status) status.textContent = `${formatTime(audio.currentTime)} / ${formatTime(duration)}`;
      };

      const setupAudioGraph = () => {
        if (audioContext || reducedMotion.matches) return;
        try {
          audioContext = new (window.AudioContext || window.webkitAudioContext)();
          analyser = audioContext.createAnalyser();
          analyser.fftSize = 128;
          frequencyData = new Uint8Array(analyser.frequencyBinCount);
          sourceNode = audioContext.createMediaElementSource(audio);
          sourceNode.connect(analyser);
          analyser.connect(audioContext.destination);
        } catch (error) {
          audioContext = null;
        }
      };

      const drawPlayer = () => {
        if (!playerCanvas || !player || player.hidden) return;
        const context = playerCanvas.getContext('2d');
        if (!context) return;
        const ratio = Math.min(devicePixelRatio || 1, 1.5);
        const width = Math.max(1, Math.round(player.clientWidth * ratio));
        const height = Math.max(1, Math.round(player.clientHeight * ratio));
        if (playerCanvas.width !== width || playerCanvas.height !== height) { playerCanvas.width = width; playerCanvas.height = height; }
        context.clearRect(0, 0, width, height);
        const bars = 42;
        if (analyser && frequencyData) analyser.getByteFrequencyData(frequencyData);
        for (let index = 0; index < bars; index += 1) {
          const value = frequencyData ? frequencyData[Math.floor(index / bars * frequencyData.length)] / 255 : 0.18;
          const barWidth = width / bars;
          const barHeight = Math.max(2, value * height * 0.72);
          context.fillStyle = index % 7 === 0 ? 'rgba(255,255,255,.55)' : 'rgba(60,116,245,.62)';
          context.fillRect(index * barWidth, height - barHeight, Math.max(1, barWidth - 2 * ratio), barHeight);
        }
        if (!reducedMotion.matches && !audio.paused && !audio.ended && !document.hidden) {
          visualFrame = requestAnimationFrame(drawPlayer);
        }
      };

      const prepareRow = (row) => {
        if (!row?.dataset.preview) return false;
        if (activeRow !== row) {
          if (activeRow) {
            activeRow.classList.remove('is-playing');
            const previousStatus = activeRow.querySelector('[data-dsiv-home-row-status]');
            if (previousStatus) previousStatus.textContent = root.dataset.previewReady;
          }
          activeRow = row;
          audio.src = row.dataset.preview;
          audio.load();
          if (player) player.hidden = false;
          if (playerTitle) playerTitle.textContent = row.dataset.title;
        }
        return true;
      };

      buttons.forEach((button) => button.addEventListener('click', async () => {
        const row = button.closest('[data-dsiv-home-track]');
        if (row === activeRow && !audio.paused) { audio.pause(); return; }
        if (!prepareRow(row)) return;
        setupAudioGraph();
        if (audioContext?.state === 'suspended') await audioContext.resume();
        try { await audio.play(); } catch (error) { announce(root.dataset.previewError); }
      }));

      playerToggle?.addEventListener('click', async () => {
        if (!activeRow) return;
        if (!audio.paused) {
          audio.pause();
          return;
        }
        setupAudioGraph();
        if (audioContext?.state === 'suspended') await audioContext.resume();
        try { await audio.play(); } catch (error) { announce(root.dataset.previewError); }
      });

      rows.forEach((row) => {
        const timeline = row.querySelector('[data-dsiv-home-timeline]');
        timeline?.addEventListener('input', () => {
          if (!prepareRow(row)) return;
          const seek = Number(timeline.value);
          if (Number.isFinite(seek)) audio.currentTime = seek;
          updateProgress();
        });
      });

      search?.addEventListener('input', applyFilters);
      filters.forEach((button) => button.addEventListener('click', () => {
        activeFilter = button.dataset.dsivHomeFilter;
        filters.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        applyFilters();
      }));
      audio.addEventListener('play', () => {
        if (playerStatus) playerStatus.textContent = root.dataset.previewPlaying;
        announce(`${root.dataset.previewPlaying}: ${activeRow?.dataset.title || ''}`);
        updateButtons();
        cancelAnimationFrame(visualFrame);
        drawPlayer();
      });
      audio.addEventListener('pause', () => { if (playerStatus) playerStatus.textContent = root.dataset.previewReady; updateButtons(); drawPlayer(); });
      audio.addEventListener('ended', () => { if (playerStatus) playerStatus.textContent = root.dataset.previewReady; updateButtons(); updateProgress(); });
      audio.addEventListener('timeupdate', updateProgress);
      audio.addEventListener('loadedmetadata', updateProgress);
      audio.addEventListener('error', () => { if (playerStatus) playerStatus.textContent = root.dataset.previewError; announce(root.dataset.previewError); updateButtons(); });
      document.addEventListener('visibilitychange', () => {
        cancelAnimationFrame(visualFrame);
        if (!document.hidden && !audio.paused && !audio.ended) drawPlayer();
      });
      applyFilters();
    };

    const initChoices = (root) => {
      const buttons = [...root.querySelectorAll('[data-dsiv-license]')];
      const title = root.querySelector('[data-dsiv-license-title]');
      const copy = root.querySelector('[data-dsiv-license-copy]');
      buttons.forEach((button) => button.addEventListener('click', () => {
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        if (title) title.textContent = button.dataset.title;
        if (copy) copy.textContent = button.dataset.copy;
      }));

      const dropButtons = [...root.querySelectorAll('[data-dsiv-drop-view]')];
      const dropText = root.querySelector('[data-dsiv-drop-copy]');
      dropButtons.forEach((button) => button.addEventListener('click', () => {
        dropButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        if (dropText) dropText.textContent = button.dataset.copy;
      }));
    };

    const init = (root) => {
      if (!root || root.dataset.dsivHomeReady === 'true') return;
      root.dataset.dsivHomeReady = 'true';
      const refreshIcons = () => window.lucide?.createIcons({ attrs: { 'aria-hidden': 'true' } });
      refreshIcons();
      document.querySelector('script[src*="lucide.min.js"]')?.addEventListener('load', refreshIcons, { once: true });
      initHero(root);
      initHeroAudio(root);
      initReveals(root);
      initCatalog(root);
      initChoices(root);
    };

    document.querySelectorAll('[data-dsiv-home]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      const loadedSection = event.target.matches?.('[data-dsiv-home]') ? event.target : event.target.querySelector('[data-dsiv-home]');
      init(loadedSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dsiv-webgl-stage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function onReady(callback) {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", callback, { once: true });
      } else {
        callback();
      }
    }

    function createShader(gl, type, source) {
      var shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        gl.deleteShader(shader);
        return null;
      }
      return shader;
    }

    function createProgram(gl) {
      var vertexShader = createShader(gl, gl.VERTEX_SHADER, [
        "attribute float a_index;",
        "uniform float u_time;",
        "uniform float u_mode;",
        "uniform vec2 u_pointer;",
        "uniform float u_ratio;",
        "uniform float u_dpr;",
        "varying float v_energy;",
        "varying float v_depth;",
        "float hash(float n) { return fract(sin(n) * 43758.5453123); }",
        "void main() {",
        "  float i = a_index;",
        "  float seed = hash(i * 997.0);",
        "  float pi = 3.14159265359;",
        "  float t = u_time * 0.001;",
        "  vec2 pointer = (u_pointer - 0.5) * 2.0;",
        "  vec2 p = vec2(0.0);",
        "  float energy = 0.0;",
        "  float depth = 0.0;",
        "  if (u_mode < 0.5) {",
        "    float x = i * 2.0 - 1.0;",
        "    float wave = sin((x * 8.0) + t * 2.6) * 0.22 + sin((x * 17.0) - t * 1.4) * 0.08;",
        "    p = vec2(x, wave + (seed - 0.5) * 0.18);",
        "    energy = 0.45 + 0.45 * sin(t * 2.0 + i * 38.0);",
        "    depth = abs(wave);",
        "  } else if (u_mode < 1.5) {",
        "    float ring = floor(i * 7.0);",
        "    float local = fract(i * 7.0);",
        "    float angle = local * pi * 2.0 + t * (0.22 + ring * 0.045);",
        "    float radius = 0.18 + ring * 0.085 + 0.035 * sin(t + seed * 8.0);",
        "    p = vec2(cos(angle) * radius, sin(angle) * radius * 0.74);",
        "    energy = 0.34 + ring * 0.08;",
        "    depth = local;",
        "  } else if (u_mode < 2.5) {",
        "    float columns = 13.0;",
        "    float rows = 9.0;",
        "    float cell = floor(i * columns * rows);",
        "    float col = mod(cell, columns);",
        "    float row = floor(cell / columns);",
        "    p = vec2((col / (columns - 1.0)) * 1.7 - 0.85, (row / (rows - 1.0)) * 1.08 - 0.54);",
        "    p += vec2(sin(t + row), cos(t * 0.8 + col)) * 0.018;",
        "    energy = 0.24 + 0.76 * step(0.72, hash(cell + floor(t * 1.6)));",
        "    depth = hash(cell * 5.0);",
        "  } else {",
        "    float angle = i * pi * 16.0 + t * 0.5;",
        "    float lane = fract(i * 9.0);",
        "    float z = fract(i * 4.0 - t * 0.12);",
        "    float radius = mix(0.9, 0.12, z) + 0.04 * sin(t + seed * 9.0);",
        "    p = vec2(cos(angle) * radius, sin(angle) * radius * 0.62);",
        "    p += vec2((lane - 0.5) * 0.12, 0.0);",
        "    energy = 1.0 - z;",
        "    depth = z;",
        "  }",
        "  p += pointer * (0.04 + seed * 0.035);",
        "  p.x = p.x / max(u_ratio, 1.0);",
        "  gl_Position = vec4(p, 0.0, 1.0);",
        "  gl_PointSize = (2.2 + energy * 5.6 + depth * 3.4) * u_dpr;",
        "  v_energy = energy;",
        "  v_depth = depth;",
        "}"
      ].join("\n"));

      var fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, [
        "precision mediump float;",
        "varying float v_energy;",
        "varying float v_depth;",
        "void main() {",
        "  vec2 center = gl_PointCoord - vec2(0.5);",
        "  float dist = length(center);",
        "  float alpha = smoothstep(0.5, 0.0, dist) * (0.34 + v_energy * 0.58);",
        "  vec3 cobalt = vec3(0.105, 0.341, 0.839);",
        "  vec3 ice = vec3(0.961, 0.973, 1.0);",
        "  vec3 warm = vec3(0.906, 0.714, 0.333);",
        "  vec3 color = mix(cobalt, warm, smoothstep(0.45, 1.0, v_energy));",
        "  color = mix(color, ice, smoothstep(0.72, 1.0, v_depth) * 0.36);",
        "  gl_FragColor = vec4(color, alpha);",
        "}"
      ].join("\n"));

      if (!vertexShader || !fragmentShader) return null;
      var program = gl.createProgram();
      gl.attachShader(program, vertexShader);
      gl.attachShader(program, fragmentShader);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return null;
      return program;
    }

    function initStage(stage) {
      if (!stage || stage.dataset.dsivWebglReady === "true") return;
      stage.dataset.dsivWebglReady = "true";

      var canvas = stage.querySelector("[data-dsiv-webgl-canvas]");
      var gl = canvas && canvas.getContext && canvas.getContext("webgl", { alpha: true, antialias: true });
      if (!gl) {
        stage.classList.add("is-static");
        return;
      }

      var program = createProgram(gl);
      if (!program) {
        stage.classList.add("is-static");
        return;
      }

      var count = 640;
      var data = new Float32Array(count);
      for (var index = 0; index < count; index += 1) {
        data[index] = count > 1 ? index / (count - 1) : 0;
      }

      var buffer = gl.createBuffer();
      var indexLocation = gl.getAttribLocation(program, "a_index");
      var timeLocation = gl.getUniformLocation(program, "u_time");
      var modeLocation = gl.getUniformLocation(program, "u_mode");
      var pointerLocation = gl.getUniformLocation(program, "u_pointer");
      var ratioLocation = gl.getUniformLocation(program, "u_ratio");
      var dprLocation = gl.getUniformLocation(program, "u_dpr");
      var pointer = { x: 0.5, y: 0.5 };
      var mode = 0;
      var active = true;
      var frameId = 0;
      var size = { ratio: 1, dpr: 1 };
      var resizeDirty = true;
      var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      gl.useProgram(program);
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
      gl.enableVertexAttribArray(indexLocation);
      gl.vertexAttribPointer(indexLocation, 1, gl.FLOAT, false, 0, 0);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE);

      function resize() {
        if (!resizeDirty) return size;
        var rect = canvas.getBoundingClientRect();
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var width = Math.max(1, Math.floor(rect.width * dpr));
        var height = Math.max(1, Math.floor(rect.height * dpr));
        if (canvas.width !== width || canvas.height !== height) {
          canvas.width = width;
          canvas.height = height;
        }
        gl.viewport(0, 0, canvas.width, canvas.height);
        size = {
          ratio: width / Math.max(height, 1),
          dpr: dpr
        };
        resizeDirty = false;
        return size;
      }

      function stop() {
        if (!frameId) return;
        window.cancelAnimationFrame(frameId);
        frameId = 0;
      }

      function start() {
        if (frameId || !active || document.hidden || reducedMotion) return;
        frameId = window.requestAnimationFrame(render);
      }

      function render(now) {
        frameId = 0;
        var size = resize();
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.useProgram(program);
        gl.uniform1f(timeLocation, reducedMotion ? 1600 : now);
        gl.uniform1f(modeLocation, mode);
        gl.uniform2f(pointerLocation, pointer.x, pointer.y);
        gl.uniform1f(ratioLocation, size.ratio);
        gl.uniform1f(dprLocation, size.dpr);
        gl.drawArrays(gl.POINTS, 0, count);
        start();
      }

      var buttons = Array.from(stage.querySelectorAll("[data-dsiv-webgl-mode]"));
      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          mode = Number(button.getAttribute("data-dsiv-webgl-mode")) || 0;
          buttons.forEach(function (item) {
            item.setAttribute("aria-pressed", item === button ? "true" : "false");
          });
          if (reducedMotion) render(performance.now());
          else start();
        });
      });

      stage.addEventListener("pointermove", function (event) {
        var rect = stage.getBoundingClientRect();
        pointer.x = (event.clientX - rect.left) / Math.max(rect.width, 1);
        pointer.y = 1 - ((event.clientY - rect.top) / Math.max(rect.height, 1));
      });

      if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function (entries) {
          active = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          if (active) start();
          else stop();
        }, { threshold: 0.05 });
        observer.observe(stage);
      }

      var resizeObserver = "ResizeObserver" in window ? new ResizeObserver(function () {
        resizeDirty = true;
        if (reducedMotion) render(performance.now());
        else start();
      }) : null;
      if (resizeObserver) resizeObserver.observe(canvas);

      function handleWindowResize() {
        resizeDirty = true;
        if (reducedMotion) render(performance.now());
        else start();
      }
      function handleVisibility() {
        if (document.hidden) stop();
        else start();
      }
      window.addEventListener("resize", handleWindowResize);
      document.addEventListener("visibilitychange", handleVisibility);
      stage.addEventListener("shopify:section:unload", function () {
        stop();
        if (observer) observer.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        window.removeEventListener("resize", handleWindowResize);
        document.removeEventListener("visibilitychange", handleVisibility);
        gl.deleteBuffer(buffer);
        gl.deleteProgram(program);
      }, { once: true });

      render(performance.now());
    }

    function initAll() {
      Array.from(document.querySelectorAll("[data-dsiv-webgl-stage]")).forEach(initStage);
    }

    onReady(initAll);
    document.addEventListener("shopify:section:load", function (event) {
      initStage(event.target && event.target.querySelector("[data-dsiv-webgl-stage]"));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
